import {ref} from "vue";

// Общее (singleton) состояние предпросмотра изображения.
// Модалка подключается один раз в App.vue, а компоненты вызывают openImagePreview.
const isOpen = ref(false);
const imageSrc = ref("");

export function openImagePreview(src) {
    if (!src) {
        return;
    }
    imageSrc.value = src;
    isOpen.value = true;
}

export function closeImagePreview() {
    isOpen.value = false;
    imageSrc.value = "";
}

export function useImagePreview() {
    return {
        isOpen,
        imageSrc,
        openImagePreview,
        closeImagePreview,
    }
}
